{
  "name": "@xiboplayer/xmr",
  "version": "0.7.23",
  "description": "XMR WebSocket client for real-time Xibo CMS commands",
  "type": "module",
  "main": "./src/index.js",
  "types": "./src/index.d.ts",
  "exports": {
    ".": "./src/index.js"
  },
  "scripts": {
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "@xiboplayer/utils": "workspace:*"
  },
  "devDependencies": {
    "vitest": "^4.1.2"
  },
  "keywords": [
    "xibo",
    "digital-signage",
    "xmr",
    "websocket",
    "real-time"
  ],
  "author": "Pau Aliagas <linuxnow@gmail.com>",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xibo-players/xiboplayer.git",
    "directory": "packages/xmr"
  },
  "homepage": "https://xiboplayer.org"
}
